import { render, staticRenderFns } from "./InviteCadastro.vue?vue&type=template&id=a02a4124&scoped=true&"
import script from "./InviteCadastro.vue?vue&type=script&lang=js&"
export * from "./InviteCadastro.vue?vue&type=script&lang=js&"
import style0 from "./InviteCadastro.vue?vue&type=style&index=0&id=a02a4124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02a4124",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VForm,VTextField})
